import React from 'react';
import StarIcon from '@mui/icons-material/Star';
import { reviews, placeholderReviews } from '../../data/reviews';

// Real reviews win. Sample reviews are only for previewing the layout in
// development; in production with no real reviews, nothing is shown.
const list = reviews.length ? reviews : process.env.NODE_ENV !== 'production' ? placeholderReviews : [];

const initials = (name) => name.split(/\s+/).map((p) => p[0]).join('').slice(0, 2).toUpperCase();

const Review = ({ review }) => (
  <figure className="sc-review">
    <div className="sc-review-stars" aria-label={`${review.rating} out of 5`}>
      {Array.from({ length: 5 }, (_, i) => (
        <StarIcon key={i} sx={{ fontSize: 14 }} className={i < review.rating ? 'on' : ''} />
      ))}
    </div>
    <blockquote>&ldquo;{review.quote}&rdquo;</blockquote>
    <figcaption>
      {review.avatar
        ? <img src={review.avatar} alt="" referrerPolicy="no-referrer" />
        : <span className="sc-review-avatar">{initials(review.name)}</span>}
      <span>
        <strong>{review.name}</strong>
        <small>{review.role}</small>
      </span>
    </figcaption>
  </figure>
);

// Several reviews in a slowly scrolling column under the Pay button.
// The list is rendered twice so the loop is seamless; it pauses on hover.
const ReviewSpotlight = () => {
  if (!list.length) return null;
  const duration = Math.max(30, list.length * 7);

  return (
    <section className="sc-reviews" aria-label="What learners say">
      <h2>What learners say</h2>
      <div className="sc-reviews-window">
        <div className="sc-reviews-track" style={{ '--sc-reviews-duration': `${duration}s` }}>
          {[...list, ...list].map((review, i) => (
            <div key={i} aria-hidden={i >= list.length}>
              <Review review={review} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ReviewSpotlight;
